import { render, staticRenderFns } from "./AdminFulfilledPage.vue?vue&type=template&id=657599f1&"
import script from "./AdminFulfilledPage.vue?vue&type=script&lang=js&"
export * from "./AdminFulfilledPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports